import { render } from "./TronAnnouncements.vue?vue&type=template&id=79344544&scoped=true"
import script from "./TronAnnouncements.vue?vue&type=script&lang=js"
export * from "./TronAnnouncements.vue?vue&type=script&lang=js"

import "./TronAnnouncements.vue?vue&type=style&index=0&id=79344544&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79344544"]])

export default __exports__